import React from 'react';

interface CustomScrollbarProps {
  children: React.ReactNode;
  className?: string;
  maxHeight?: string;
}

const CustomScrollbar: React.FC<CustomScrollbarProps> = ({
  children,
  className = '',
  maxHeight = 'max-h-60',
}) => {
  return (
    <div
      className={`overflow-y-auto scrollbar-thin scrollbar-thumb-[#4A082D] scrollbar-track-transparent scrollbar-thumb-rounded-full ${maxHeight} ${className}`}
    >
      {children}
    </div>
  );
};

export default CustomScrollbar;
